module.exports = __webpack_public_path__ + "img/meditation_5--active.0ff0d0da.svg";